import { Component, type ErrorInfo, type ReactNode } from "react";

type AppErrorBoundaryProps = {
  fallback: ReactNode;
  children: ReactNode;
};

type AppErrorBoundaryState = { hasError: boolean };

/** Shows the fallback instead of a blank page when rendering throws. */
export class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Marketplace render error", error, info.componentStack);
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
